<template>
  <div
    v-b-tooltip.hover
    class="profile-default"
    :class="[
      { xs: size === 'xs', sm: size === 'sm', md: size === 'md', lg: size === 'lg', xl: size === 'xl',xxl: size==='xxl' },
      'bg-' + cirgleBgColor,
    ]"
    :title="fullName"
  >
    {{ firstLetter }}{{ secondLetter }} 
  </div>
</template>

<script>
export default {
  name: 'profile-default',

  props: {
    size: {
      type: String,
      default: 'md',
    },
    firstName: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      colors: ['primary', 'tertiary', 'success', 'info', 'warning', 'danger', 'dark'],
      cirgleBgColor: null,
      firstLetter: null,
      secondLetter: null,
    }
  },

  computed: {
    fullName() {
      return `${this.firstName} ${this.lastName}`
    },
  },

  mounted() {
    this.getColor()
    this.formatName()
  },

  methods: {
    getColor() {
      this.cirgleBgColor = this.colors[this.hashString(this.firstName + this.lastName) % this.colors.length]
    },

    formatName() {
      ;[this.firstLetter] = this.firstName
      this.firstLetter = this.firstLetter.toUpperCase()
      ;[this.secondLetter] = this.lastName
      this.secondLetter = this.secondLetter.toUpperCase()
    },
    hashString(string) {
      return string
        .split('')
        .map((char) => char.charCodeAt(0))
        .reduce((a, b) => a + b, 0)
    },
  },
}
</script>

<style scoped>
</style>